<template>
	<div class="sidebar-container">
		<!-- 品牌区域 -->
		<div class="sidebar-brand">
			<div class="brand-logo">
				<svg class="logo-icon" viewBox="0 0 24 24">
					<path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M11,17H9V15H11V17M13,13H11L10.5,6H13.5L13,13Z"/>
				</svg>
			</div>
			<span class="brand-title">医疗管理</span>
		</div>

		<!-- 导航菜单 -->
		<div class="sidebar-menu">
			<el-scrollbar>
				<el-menu class="menu-list" default-active="0" :unique-opened="true">
					<!-- 系统首页 -->
					<el-menu-item index="0" @click="menuHandler('')" class="menu-item">
						<svg class="menu-icon" viewBox="0 0 24 24">
							<path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"/>
						</svg>
						<span class="menu-text">数据统计</span>
					</el-menu-item>
					

					<el-submenu index="1" class="menu-submenu">
					<template slot="title">
							<svg class="menu-icon" viewBox="0 0 24 24">
								<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
							</svg>
							<span class="menu-text">系统设置</span>
					</template>
						<el-menu-item index="1-1" @click="menuHandler('updatePassword')" class="submenu-item">
							修改密码
						</el-menu-item>
						<el-menu-item index="1-2" @click="menuHandler('center')" class="submenu-item">
							个人信息
						</el-menu-item>
						<el-menu-item v-if="role === '管理员'" index="1-3" @click="menuHandler('users')" class="submenu-item">
							后台账号管理
						</el-menu-item>
				</el-submenu>
				
					<!-- 动态菜单 -->
					<el-submenu 
						v-for="(menu, index) in menuList.backMenu" 
						:key="menu.menu" 
						:index="index + 2 + ''"
						class="menu-submenu"
					>
					<template slot="title">
							<svg class="menu-icon" viewBox="0 0 24 24">
								<path :d="getMenuIconPath(index)"/>
							</svg>
							<span class="menu-text">{{ menu.menu }}</span>
					</template>
						<el-menu-item 
							v-for="(child, sort) in menu.child" 
							:key="sort" 
							:index="(index + 2) + '-' + sort" 
							@click="menuHandler(child.tableName)"
							class="submenu-item"
						>
							{{ child.menu }}
						</el-menu-item>
				</el-submenu>
			</el-menu>
		</el-scrollbar>
		</div>
	</div>
</template>

<script>
import menu from '@/utils/menu'
export default {
	data() {
		return {
			menuList: [],
			dynamicMenuRoutes: [],
			role: '',
			icons: [
				'el-icon-s-cooperation',
				'el-icon-s-order',
				'el-icon-s-platform',
				'el-icon-s-fold',
				'el-icon-s-unfold',
				'el-icon-s-operation',
				'el-icon-s-promotion',
				'el-icon-s-release',
				'el-icon-s-ticket',
				'el-icon-s-management',
				'el-icon-s-open',
				'el-icon-s-shop',
				'el-icon-s-marketing',
				'el-icon-s-flag',
				'el-icon-s-comment',
				'el-icon-s-finance',
				'el-icon-s-claim',
				'el-icon-s-custom',
				'el-icon-s-opportunity',
				'el-icon-s-data',
				'el-icon-s-check',
				'el-icon-s-grid',
				'el-icon-menu',
				'el-icon-chat-dot-square',
				'el-icon-message',
				'el-icon-postcard',
				'el-icon-position',
				'el-icon-microphone',
				'el-icon-close-notification',
				'el-icon-bangzhu',
				'el-icon-time',
				'el-icon-odometer',
				'el-icon-crop',
				'el-icon-aim',
				'el-icon-switch-button',
				'el-icon-full-screen',
				'el-icon-copy-document',
				'el-icon-mic',
				'el-icon-stopwatch',
			],
			menulistBorderBottom: {},
		}
	},
	mounted() {
		const menus = menu.list()
		if(menus) {
			this.menuList = menus
		} else {
			let params = {
				page: 1,
				limit: 1,
				sort: 'id',
			}
			
			this.$http({
				url: "menu/list",
				method: "get",
				params: params
			}).then(({
				data
			}) => {
				if (data && data.code === 0) {
					this.menuList = JSON.parse(data.data.list[0].menujson);
					this.$storage.set("menus", this.menuList);
				}
			})
		}
		this.role = this.$storage.get('role')
		
		for(let i=0;i<this.menuList.length;i++) {
			if(this.menuList[i].roleName == this.role) {
				this.menuList = this.menuList[i];
				break;
			}
		}
	},
	created(){
		this.icons.sort(()=>{
			return (0.5-Math.random())
		})
	},
	methods: {
		getMenuIconPath(index) {
			const iconPaths = [
				"M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.98C19.47,12.66 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11.02L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.65 15.48,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.52,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11.02C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.66 4.57,12.98L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.52,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.48,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.98Z", // 设置
				"M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8L6,7M4,19H8L6,17M4,14H8L6,12", // 列表管理
				"M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z", // 数据管理
				"M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z", // 审核管理
				"M16,6L18.29,8.29L13.41,13.17L9.41,9.17L10.83,7.75L13.41,10.34L16,6M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z", // 订单管理
				"M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z", // 用户管理
				"M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z", // 系统配置
			];
			return iconPaths[index % iconPaths.length];
		},
		
		menuHandler(name) {
			let router = this.$router;
			name = '/' + name;
			router.push(name);
		},
	}
}
</script>
<style lang="scss" scoped>
.sidebar-container {
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: #ffffff;
}

.sidebar-brand {
	padding: 20px 16px;
	display: flex;
	align-items: center;
	gap: 12px;
	border-bottom: 1px solid #f1f5f9;
	flex-shrink: 0;

	.brand-logo {
		width: 36px;
		height: 36px;
		background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);

		.logo-icon {
			width: 20px;
			height: 20px;
			fill: white;
		}
	}

	.brand-title {
		font-size: 16px;
		font-weight: 600;
		color: #1e293b;
		letter-spacing: -0.025em;
	}
}

.sidebar-menu {
	flex: 1;
	overflow: hidden;

	  .el-scrollbar {
	    height: 100%;
	}

	.menu-list {
		border: none;
		background: transparent;
		
		// 菜单项样式
		.menu-item,
		:deep(.el-menu-item) {
			height: 48px;
			line-height: 48px;
			padding: 0 16px;
			margin: 4px 8px;
			border-radius: 8px;
			color: #64748b;
			font-weight: 500;
			font-size: 14px;
			border: none;
			background: transparent;
			transition: all 0.2s ease;
			display: flex;
			align-items: center;
			gap: 12px;

			&:hover {
				background: #f1f5f9;
				color: #374151;
			}

			&.is-active {
				background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
				color: white;
				box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);

				.menu-icon {
					fill: white;
				}
			}

			.menu-icon {
				width: 18px;
				height: 18px;
				fill: #64748b;
				flex-shrink: 0;
				transition: fill 0.2s ease;
					}
		
			.menu-text {
				flex: 1;
			}
		}

		// 子菜单样式
		.menu-submenu {
			margin: 4px 8px;
			border-radius: 8px;
			overflow: hidden;

			:deep(.el-submenu__title) {
				height: 48px;
				line-height: 48px;
				padding: 0 16px;
				color: #64748b;
				font-weight: 500;
				font-size: 14px;
				border: none;
				background: transparent;
				border-radius: 8px;
				transition: all 0.2s ease;
				display: flex;
				align-items: center;
				gap: 12px;

				&:hover {
					background: #f1f5f9;
					color: #374151;
				}

				.menu-icon {
					width: 18px;
					height: 18px;
					fill: #64748b;
					flex-shrink: 0;
					transition: fill 0.2s ease;
				}

				.menu-text {
					flex: 1;
				}

				.el-submenu__icon-arrow {
					right: 16px;
					font-size: 12px;
					color: #94a3b8;
					transition: transform 0.3s ease;
				}
			}

			&.is-opened {
				:deep(.el-submenu__title) {
					background: #f8fafc;
					color: #374151;

					.el-submenu__icon-arrow {
						transform: rotateZ(180deg);
					}
				}
			}

			// 子菜单容器
			:deep(.el-menu) {
				background: #f8fafc;
				border: none;
						margin: 0;

				.submenu-item {
					height: 40px;
					line-height: 40px;
					padding: 0 48px;
					color: #64748b;
					font-size: 13px;
					font-weight: 400;
					background: transparent;
					border: none;
					transition: all 0.2s ease;
					position: relative;

					&:hover {
						background: #e2e8f0;
						color: #374151;
					}

					&.is-active {
						background: #3b82f6;
						color: white;
						
						&::before {
							content: '';
							position: absolute;
							left: 28px;
							top: 50%;
							transform: translateY(-50%);
							width: 4px;
							height: 4px;
							border-radius: 50%;
							background: white;
						}
					}
				}
			}
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.sidebar-brand {
		padding: 16px 12px;

		.brand-logo {
			width: 32px;
			height: 32px;

			.logo-icon {
				width: 18px;
				height: 18px;
			}
		}

		.brand-title {
			font-size: 15px;
		}
	}

	.sidebar-menu .menu-list {
		.menu-item,
		:deep(.el-menu-item) {
			height: 44px;
			line-height: 44px;
			margin: 3px 6px;
			padding: 0 12px;
			font-size: 13px;

			.menu-icon {
				width: 16px;
				height: 16px;
			}
		}

		.menu-submenu {
			margin: 3px 6px;

			:deep(.el-submenu__title) {
				height: 44px;
				line-height: 44px;
				padding: 0 12px;
				font-size: 13px;

				.menu-icon {
					width: 16px;
					height: 16px;
				}
			}

			:deep(.el-menu) {
				.submenu-item {
					height: 36px;
					line-height: 36px;
						padding: 0 40px;
					font-size: 12px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.sidebar-brand {
		padding: 12px 10px;

		.brand-logo {
			width: 28px;
			height: 28px;

			.logo-icon {
				width: 16px;
				height: 16px;
					}
		}

		.brand-title {
			font-size: 14px;
		}
			  }
	  	}
</style>
